export const SOFTLINE_SETTINGS_NFC_READER = 'nfc';

export const SOFTLINE_FEATURE_NFC_READER = "nfcReader";
